import React, { Component } from 'react';
import { connect } from 'react-redux';

import Speaker from './Speaker';


class AllSpeakers extends Component {
  render() {
    let allSpeakers = [];
    this.props.sections.forEach((section) => {
      section.speakerViewList.forEach(speaker => {
          allSpeakers.push(<Speaker key={speaker.speakerShortView.idStr} speakerData={speaker.speakerShortView}/>)
      })
    });
    return (
      <div className='speakers__container speakers__container_users'>
        {allSpeakers}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    sections: state.speakers.sections
});

export default connect(mapStateToProps)(AllSpeakers);



// WEBPACK FOOTER //
// ./src/speakers-page/components/AllSpeakers.js